var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:golf-course"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3216 13.9997C13.0438 13.9997 12.8076 13.9023 12.6129 13.7077C12.4183 13.513 12.3212 13.277 12.3216 12.9997C12.3216 12.7219 12.4189 12.4857 12.6136 12.291C12.8083 12.0963 13.0443 11.9992 13.3216 11.9997C13.5994 11.9997 13.8356 12.097 14.0303 12.2917C14.2249 12.4863 14.3221 12.7223 14.3216 12.9997C14.3216 13.2775 14.2243 13.5137 14.0296 13.7083C13.8349 13.903 13.5989 14.0001 13.3216 13.9997ZM6.98828 14.6663C5.87717 14.6663 4.93273 14.5357 4.15495 14.2743C3.37717 14.013 2.98828 13.6992 2.98828 13.333C2.98828 13.0775 3.17161 12.8497 3.53828 12.6497C3.90495 12.4497 4.38828 12.2886 4.98828 12.1663V13.333H6.32161V1.33301L11.6549 3.93301L7.65495 5.99967V12.033C8.6105 12.0886 9.40495 12.2359 10.0383 12.475C10.6716 12.7141 10.9883 13.0001 10.9883 13.333C10.9883 13.6997 10.5994 14.0137 9.82161 14.275C9.04384 14.5363 8.09939 14.6668 6.98828 14.6663Z",
    fill: "white",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIcon);
export default __webpack_public_path__ + "static/media/eventIcon.0565f2e4e8365b97033e756346478ad6.svg";
export { ForwardRef as ReactComponent };